import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { TextInput, REQUIRED_ERROR_MESSAGE } from "@SeemplicityDev/shared";

interface UserEditableFieldsProps {
  isDisabled?: boolean;
}

const UserEditableFields: React.FC<UserEditableFieldsProps> = ({
  isDisabled,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Controller
        name={"firstName"}
        defaultValue={null}
        render={({ field: { onChange, onBlur, value } }) => (
          <TextInput
            placeholder={"Type first name"}
            type={"text"}
            label={"First Name"}
            labelTop
            required
            error={errors && errors.firstName ? errors.firstName : null}
            value={value}
            onChange={(val: React.ChangeEvent<HTMLInputElement>) =>
              onChange(val)
            }
            onBlur={onBlur}
            data-testid={`first-name`}
            disabled={isDisabled}
          />
        )}
        rules={{ required: REQUIRED_ERROR_MESSAGE }}
        control={control}
      />
      <Controller
        name={"lastName"}
        defaultValue={""}
        render={({ field: { onChange, onBlur, value } }) => (
          <TextInput
            placeholder={"Type last name"}
            type={"text"}
            label={"Last Name"}
            labelTop
            error={errors && errors.lastName ? errors.lastName : null}
            value={value}
            onChange={(val: React.ChangeEvent<HTMLInputElement>) =>
              onChange(val)
            }
            onBlur={onBlur}
            data-testid={`last-name`}
            required
            disabled={isDisabled}
          />
        )}
        control={control}
      />
    </>
  );
};

export default UserEditableFields;
